/**
 * hardcode paths for context
 * https://webpack.js.org/guides/dependency-management/#require-with-expression
 */
const resources = {
  utcom: lng => require('../locales/' + lng + '/utcom.json'),
  'application-bootstrapper': lng =>
    require('../node_modules/@unitedtraders/application-bootstrapper/locales/' +
      lng +
      '/application-bootstrapper.json'),
  validator: lng =>
    require('../node_modules/@unitedtraders/aurora-javascript-utils/locales/' +
      lng +
      '/validator.json')
};

const formatResources = (resources, languages = ['en', 'ru']) =>
  Object.keys(resources).reduce((result, ns) => {
    languages.forEach(lng => {
      result[lng] = result[lng] || {};
      result[lng][ns] = resources[ns](lng);
    });
    return result;
  }, {});

const defaultMenuOptions = [
  { code: 'ru', label: 'Русский', shortLabel: 'RUS' },
  { code: 'en', label: 'English', shortLabel: 'ENG' }
];

const customizeI18nSettings = i18n => ({
  ...i18n,
  resources: formatResources(resources, i18n.whitelist),
  ns: Object.keys(resources),
  defaultNS: 'utcom',
  fallbackNS: Object.keys(resources),
  menuOptions: i18n.menuOptions || defaultMenuOptions
});

export default customizeI18nSettings;



// WEBPACK FOOTER //
// ./src/customizeI18nSettings.js